import { gql } from '@apollo/client';

const DELETE_SUPPLIER_ORDER_STATUS = gql`mutation deleteOrderStatus($supplierStatusId: Int!) {
	incomingOrders {
		deleteSupplierOrderStatus(supplierStatusId: $supplierStatusId)
	}
}`;

export default DELETE_SUPPLIER_ORDER_STATUS;